import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { NotificationModalProps } from '@masfront/common-b2c'

import ModalMessages from '../models/modal.model'
import { changeModal, setOpenModal } from '../store/modal.reducer'
import { selectModal } from '../store/modal.selectors'

interface useModalReturn {
  modal: NotificationModalProps
  setIsOpen: (isOpen: boolean) => void
  setModalConfig: (modalConfig: NotificationModalProps) => void
  selectAndOpenModalFromList: (modalName: string, modalList: ModalMessages) => void
  onCloseModal: () => void
}

export default function useModal(): useModalReturn {
  const dispatch = useDispatch()
  const modal = useSelector(selectModal)

  const [receivedOpen, setReceivedOpen] = useState(false)
  const [modalName, setModalName] = useState('')
  const [modalList, setModalList] = useState<ModalMessages>()

  useEffect(() => {
    if (receivedOpen) {
      dispatch(setOpenModal({ isOpen: receivedOpen }))
      setReceivedOpen(false)
    }
  }, [modal, receivedOpen])

  function setModalConfig(modalConfiguration: NotificationModalProps) {
    dispatch(changeModal({ open: false, title: '', description: '', actions: [], type: '' }))
    dispatch(changeModal(modalConfiguration))
  }

  function setIsOpen(isOpen: boolean) {
    setReceivedOpen(isOpen)
  }

  useEffect(() => {
    if (modalName && modalList) {
      const modalMessage = modalList[modalName]
      setModalConfig(modalMessage)
      setIsOpen(true)
    }
  }, [modalName, modalList])

  function selectAndOpenModalFromList(messageModalName: string, messageModalList: ModalMessages) {
    setModalList(messageModalList)
    setModalName(messageModalName)
  }

  function onCloseModal() {
    dispatch(setOpenModal({ isOpen: false }))
    return modal.onClose ? modal.onClose() : null
  }

  return {
    modal,
    setIsOpen,
    setModalConfig,
    selectAndOpenModalFromList,
    onCloseModal,
  }
}
